// The nudge on the portal home: what is open and whether it can be paid
// online, from the same billing answer the Payments page reads.

import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchClientBilling, getClientToken } from "../../../api/clientPortal";
import { fmtCents } from "../../../lib/money";

export function PortalPaymentDue() {
  const token = getClientToken();
  // Same key as the Payments page, so the two share one fetch. A billing
  // failure only costs this card - the case view must still render.
  const billingQ = useQuery({
    queryKey: ["portal", "billing", token],
    queryFn: () => fetchClientBilling(),
    retry: false,
  });
  const openBills = (billingQ.data?.invoices ?? []).filter((i) => i.status === "open");
  const openTotalCents = openBills.reduce((sum, i) => sum + i.amountCents, 0);
  // A sandbox key still counts as available, and the Payments page then
  // tells the client to call the office: the home promises no more than it.
  const payOnline = !!billingQ.data?.available && !billingQ.data?.testMode;

  if (openBills.length === 0) return null;
  return (
    <section className="portal-card">
      <h2>Payment due</h2>
      <p className="portal-note">
        {openBills.length === 1
          ? `You have an open invoice for ${fmtCents(openTotalCents)}`
          : `You have ${openBills.length} open invoices totaling ${fmtCents(openTotalCents)}`}
        {payOnline ? " you can pay online." : ". Please call our office to pay."}
        {/* Bills issued online are not the whole fee: the office
            ledger is a second, larger number one page away. */}
        {billingQ.data?.balanceOnFile
          ? " Your balance with the office is on the Payments page."
          : ""}
      </p>
      <Link className="portal-cta" to="/portal/payments">
        {payOnline ? "View and pay" : "View your bills"}
      </Link>
    </section>
  );
}
